import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';

@Component({
  selector: 'app-meet-the-creatics',
  templateUrl: './meet-the-creatics.component.html',
  styleUrls: ['./meet-the-creatics.component.css']
})
export class MeetTheCreaticsComponent implements OnInit, AfterViewInit {

  screenWidth: number;
  itemsPerSlide: number;
  userData: any = []
  data = false;
  searchItem = true
  close = false
  searchQuery: string = '';
  searchResults: any[] = [];
  carouselOptions = {
    loop: false,
    items: 1,
    dots: false,
    nav: true,
    navText: ["<i class='bi bi-caret-left-fill'></i>","<i class='bi bi-caret-right-fill'></i>"],
    autoplay: false,
    autoplayTimeout: 4000,
    responsive: {
      0: {
        items: 1,
        margin:10
      },
      499:{
        items: 2,
        margin:20
      },
      768: {
        items: 3,
        margin:20

      },
      940: {
        items: 3,
        margin:20
      },
      1200:{
        items: 4,
        margin:20
      },
      1800: {
        items: 6,
        margin:20
      }
    }
  };
 
  treasuryOptions = {
    loop: false, // Disable looping to prevent item repetition
    items: 4, // Number of items to display at a time
    dots: false,
    nav: true,
    navText: ["<i class='bi bi-caret-left-fill'></i>", "<i class='bi bi-caret-right-fill'></i>"],
    autoplay: false,
    autoplayTimeout: 4000,
    slideBy: 4,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
        margin: 10
      },
      499: {
        items: 2,
        slideBy: 2,
        margin: 20
      },
      768: {
        items: 3,
        slideBy: 3,
        margin: 20
      },
      940: {
        items: 3,
        slideBy: 3,
        margin: 20
      },
      1200: {
        items: 4,
        slideBy: 4,
        margin: 20
      },
      1800: {
        items: 6,
        slideBy: 6,
        margin: 20
      }
    }
  };
  
  carouselContents: any[] = [];
  treasuryContents: any[] = [];
  treasuryContentsArray: any[] = [];
  treasuryContentsResize: any[] = [];
  userProfiles: any;
  showCarousel=false
  description: any;
  heading: any;
  bannerImage: any;

  constructor(private service: AdminService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.service.getMeetCreatics().subscribe(
      (res: any) => {
        this.heading = res.heading;
        this.description = res.description
        this.bannerImage = res.bannerImage
      }
    );
  }    

  ngAfterViewInit(): void {
    this.service.getMeetCreaticsList().subscribe(
      (res: any) => {
        this.carouselContents = res.carouselContent.flat();
        this.treasuryContentsArray = res.topRatedTreasures.flat();
        this.cdr.detectChanges();
        this.getScreenSize();
      }
    );
  }
  
  getScreenSize() {
    this.screenWidth = window.innerWidth;
    this.calculateItemsPerSlide();
    this.populateTreasuryContents();
  }
  
  populateTreasuryContents() {
    const numSlides = Math.ceil(this.treasuryContentsArray.length / this.itemsPerSlide);
    let populatedContents: any = [];
    for (let i = 0; i < numSlides; i++) {
      const startIndex = i * this.itemsPerSlide;
      const endIndex = Math.min((i + 1) * this.itemsPerSlide, this.treasuryContentsArray.length);
      const slideItems = this.treasuryContentsArray.slice(startIndex, endIndex);
      populatedContents.push(slideItems);
       // Check if there are fewer items than itemsPerSlide
      if ((populatedContents[i].length) < this.itemsPerSlide) {
        const numEmptySlides = this.itemsPerSlide - (populatedContents[i].length);
        for (let p = 0; p < numEmptySlides; p++) {
          populatedContents[i].push([]);
        }
      }
    }
    this.treasuryContents = populatedContents.flat();
    setTimeout(()=>{
      this.showCarousel= true;
    },2000)
  }

  calculateItemsPerSlide() {
    if (this.screenWidth >= 1451) {
      this.itemsPerSlide = 4;
    } else if (this.screenWidth >= 1450) {
      this.itemsPerSlide = 3;
    } else if (this.screenWidth >= 768) {
      this.itemsPerSlide = 2;
    } else {
      this.itemsPerSlide = 1;
    }
  }

  // Function to check based on the screen size
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.getScreenSize();
  }

  redirectToProfile(userId: number): void {
    this.router.navigate(['/userProfiles', userId]); 
  }
  
  search() {

    if (this.searchQuery.length < 3) {
      return;
    }

    this.service.fetchUser(this.searchQuery).subscribe(res => {
      this.searchResults = res;
      if (this.searchResults.length == 0) {
        this.data = false
      }
    },
      error => {
        console.log('Error fetching search results', error);
      }

    );

  }

  onSearchQueryChange(event: any) {
    if (this.searchQuery.length > 0) {
      this.close = true
      this.searchItem = false

      if (this.searchQuery.length < 3) {
        this.data = false

      }
      else {
        this.data = true
      }
      return;
    }

    else {
      this.close = false
      this.searchItem = true
      return;
    }
  }

  clear(){
    this.searchQuery = ''
    this.data =false
    this.close = false;
    this.searchItem= true
  }

  getNumberOfItems(): number {
    const numberOfItems = this.carouselContents.length;
    return numberOfItems;
  }

  toPlay(){
    const playSection = document.getElementById("play");
    if (playSection) {
        playSection.scrollIntoView({ behavior: "smooth", block: "end" });
        // window.scroll(0, 840);
    }
  }

  toBottom(){
    const meetCreaticsSection = document.getElementById("content");
    if (meetCreaticsSection) {
      meetCreaticsSection.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }

  toMeetCreatics() {
    const meetCreaticsSection = document.getElementById("meetCreatics");
    if (meetCreaticsSection) {
      meetCreaticsSection.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }

}

